// registration/RegistrationOverview.js
import React, { useState, useEffect } from "react"
import api from "../../services/api"

function RegistrationOverview() {
  console.log("[REGISTRATION OVERVIEW] Rendering")
  const [registrations, setRegistrations] = useState([])
  const [status, setStatus] = useState("")
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [barcode, setBarcode] = useState("")
  const [barcodes, setBarcodes] = useState([])
  const [selectedRegistration, setSelectedRegistration] = useState(null)
  const [detailStatus, setDetailStatus] = useState("")

  useEffect(() => {
    console.log("[REGISTRATION OVERVIEW] useEffect init")
    fetchFilterOptions()
    fetchRegistrations()
  }, [])

  const fetchFilterOptions = async () => {
    console.log("[REGISTRATION OVERVIEW] fetchFilterOptions")
    try {
      const res = await api.get("/registration-overview/filters")
      setBarcodes(res.data.barcodes)
    } catch (err) {
      console.log("[REGISTRATION OVERVIEW] filters error", err)
      setStatus("Error fetching filter options")
    }
  }

  const fetchRegistrations = async () => {
    console.log("[REGISTRATION OVERVIEW] fetchRegistrations")
    try {
      const params = {}
      if (fromDate) params.fromDate = fromDate
      if (toDate) params.toDate = toDate
      if (barcode) params.barcode = barcode
      const res = await api.get("/registration-overview", { params })
      setRegistrations(res.data.registrations)
    } catch (err) {
      console.log("[REGISTRATION OVERVIEW] fetch error", err)
      setStatus("Error fetching registrations")
    }
  }

  const handleDetail = async (id) => {
    console.log("[REGISTRATION OVERVIEW] handleDetail", id)
    try {
      setSelectedRegistration(null)
      setDetailStatus("Loading details...")
      const res = await api.get(`/registration-overview/${id}`)
      setSelectedRegistration(res.data.registration)
      setDetailStatus("")
    } catch (err) {
      console.log("[REGISTRATION OVERVIEW] detail error", err)
      setDetailStatus("Error fetching registration details")
    }
  }

  const handleSearch = () => {
    console.log("[REGISTRATION OVERVIEW] handleSearch")
    fetchRegistrations()
  }

  const handleClear = () => {
    console.log("[REGISTRATION OVERVIEW] handleClear")
    setFromDate("")
    setToDate("")
    setBarcode("")
    setSelectedRegistration(null)
    setDetailStatus("")
    fetchRegistrations()
  }

  return (
    <div>
      <h2>Registration Overview</h2>
      <div style={{ marginBottom: "1rem" }}>
        <label>From Date</label>
        <input
          type="date"
          value={fromDate}
          onChange={e => setFromDate(e.target.value)}
        />
        <label style={{ marginLeft: 10 }}>To Date</label>
        <input
          type="date"
          value={toDate}
          onChange={e => setToDate(e.target.value)}
        />
        <label style={{ marginLeft: 10 }}>Questionnaire Name</label>
        <select
          value={barcode}
          onChange={e => setBarcode(e.target.value)}
        >
          <option value="">All</option>
          {barcodes.map((b, idx) => (
            <option key={idx} value={b}>
              {b}
            </option>
          ))}
        </select>
        <button style={{ marginLeft: 10 }} onClick={handleSearch}>
          Search
        </button>
        <button style={{ marginLeft: 10 }} onClick={handleClear}>
          Clear
        </button>
      </div>
      {status && <p>{status}</p>}
      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>Registered By</th>
            <th>Questionnaire Name</th>
            <th>Registration Date</th>
            <th>PDF Link</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {registrations.map(r => (
            <tr key={r._id}>
              <td>{r.name} {r.surname}</td>
              <td>{r.barcodeName}</td>
              <td>{new Date(r.createdAt).toLocaleString()}</td>
              <td>
                {r.pdfUrl ? (
                  <a href={r.pdfUrl} target="_blank" rel="noreferrer">
                    Open PDF
                  </a>
                ) : (
                  "No PDF"
                )}
              </td>
              <td>
                <button onClick={() => handleDetail(r._id)}>Details</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: "1rem" }}>
        {detailStatus && <p>{detailStatus}</p>}
        {selectedRegistration && (
          <div style={{ border: "1px solid #ccc", padding: "10px" }}>
            <h3>Registration Details</h3>
            <p>
              <b>Registered By:</b> {selectedRegistration.name} {selectedRegistration.surname}
            </p>
            <p>
              <b>Questionnaire Name:</b> {selectedRegistration.barcodeName}
            </p>
            <p>
              <b>Created At:</b>{" "}
              {new Date(selectedRegistration.createdAt).toLocaleString()}
            </p>
            {selectedRegistration.answers && selectedRegistration.answers.length ? (
              <div>
                <h4>Answers</h4>
                {selectedRegistration.answers.map((ans, i) => (
                  <div key={i}>
                    <b>{ans.fieldLabel}:</b> {String(ans.value)}
                  </div>
                ))}
              </div>
            ) : null}
            <div style={{ marginTop: "1rem" }}>
              <b>Preferred Language:</b> {selectedRegistration.preferredLanguage}
            </div>
            <div>
              <b>Phone:</b> {selectedRegistration.plainPhone || ""}
            </div>
            <div>
              <b>Signature:</b>{" "}
              {selectedRegistration.signature ? (
                <img
                  src={selectedRegistration.signature}
                  alt="signature"
                  style={{ maxWidth: 200, display: "block", marginTop: 5 }}
                />
              ) : (
                "No signature"
              )}
            </div>
            <div style={{ marginTop: "1rem" }}>
              <b>Consent Store Data:</b> {selectedRegistration.consentStoreData ? "Yes" : "No"}
            </div>
            <div>
              <b>Consent Read Everything:</b>{" "}
              {selectedRegistration.consentReadEverything ? "Yes" : "No"}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default RegistrationOverview